export function getArweaveUrl(hash: string) {
  return `https://arweave.net/${hash}`
}

export function getArweaveTxUrl(hash: string) {
  return `https://viewblock.io/arweave/tx/${hash}`
}
